import { createSlice } from '@reduxjs/toolkit';

/**
 * 계약 목록.
 *
 * 발급 한도가 계약에 붙으므로 계약이 없으면 아무것도 발급할 수 없다. 1 파트너 : N 계약이고
 * 발급할 때 어느 계약에서 차감할지 고른다. 여기 남은 것은 발급 화면이 고를 목록뿐이다.
 *
 * 등록과 수정은 리덕스를 거치지 않는다. 계약을 만드는 화면(등록 모달)은 계약을 만든 뒤
 * 할당량까지 이어서 넣어야 하고, 고치는 화면(계약 상세)은 한 건만 들고 있다 - 둘 다 그
 * 화면 안에서 끝나는 일이라 전역 상태에 둘 이유가 없다.
 */
const initialState = {
    list: [],
    loading: false,
    error: null,
};

export const contractSlice = createSlice({
    name: 'contract',
    initialState,
    reducers: {
        fetchContractListRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchContractListSuccess: (state, action) => {
            state.list = action.payload ?? [];
            state.loading = false;
        },
        fetchContractListFailure: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const {
    fetchContractListRequest,
    fetchContractListSuccess,
    fetchContractListFailure,
} = contractSlice.actions;

export default contractSlice.reducer;
